import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceWidgetConfigurationCustomizeRoute: InvariantJiraRoute = {
	name: 'csm-experience-widget-configuration-customize',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed/:widgetId/customize',
	exact: true,
};
